module.exports = "https://static.zego.com/_next/static/images/FlexiblePrivateHire-08f96a02ea0431ca9d003f923539881e.svg";